module.exports = __webpack_public_path__ + "img/sv78on.da0844d9.svg";